"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppEditorSidebar_1 = __importDefault(require("./AppEditorSidebar"));
var AppPreview_1 = __importDefault(require("./AppPreview"));
var SettingsDrawerContent_1 = __importDefault(require("./SettingsDrawerContent"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var inertia_1 = require("@inertiajs/inertia");
var AppEditor_module_css_1 = __importDefault(require("./AppEditor.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var SettingUtils_1 = require("@/functions/SettingUtils");
var react_i18next_1 = require("react-i18next");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var DeveloperToolbar_1 = __importDefault(require("../DeveloperToolbar"));
var AppEditor = function (_a) {
    var appData = _a.appData;
    var logger = q_play_core_1.logManager.getLogger();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)(appData), editorAppData = _b[0], setEditorAppData = _b[1];
    var _c = (0, react_1.useState)("App Info"), activeTab = _c[0], setActiveTab = _c[1];
    var canvasRef = (0, react_1.useRef)(null);
    var tabs = [
        { name: "App Info", icon: pro_solid_svg_icons_1.faMemoCircleInfo },
        { name: "Rendering Options", icon: pro_solid_svg_icons_1.faFilter },
        { name: "Settings", icon: pro_solid_svg_icons_1.faSliders, dataCy: "appEditorSettingsTab" },
        { name: "Translations", icon: free_solid_svg_icons_1.faLanguage },
    ];
    var handleTabChange = function (tab) { return setActiveTab(tab); };
    var handleBackToDeveloperPage = function () {
        inertia_1.Inertia.visit("/developer");
    };
    var handleAppDataUpdate = function (updates) {
        setEditorAppData(function (prev) { return (__assign(__assign({}, prev), updates)); });
    };
    var handleUpdateSetting = function (updatedSetting, oldKey) {
        try {
            setEditorAppData(function (prev) {
                var newKey = updatedSetting.key;
                var newSettings = __assign({}, prev.settings);
                var settingsOrder = Object.keys(prev.settings);
                if (oldKey && oldKey !== newKey) {
                    delete newSettings[oldKey];
                    settingsOrder = settingsOrder.map(function (key) { return (key === oldKey ? newKey : key); });
                }
                if (!settingsOrder.includes(newKey)) {
                    settingsOrder.push(newKey);
                }
                newSettings[newKey] = (0, SettingUtils_1.convertSettingToBackendFormat)(updatedSetting);
                var orderedSettings = settingsOrder.reduce(function (ordered, key) {
                    if (newSettings[key]) {
                        ordered[key] = newSettings[key];
                    }
                    return ordered;
                }, {});
                return __assign(__assign({}, prev), { settings: orderedSettings });
            });
        }
        catch (error) {
            logger.error("Error updating setting:", error);
        }
    };
    var handleRemoveSetting = function (key) {
        var updatedSettings = __assign({}, editorAppData.settings);
        delete updatedSettings[key];
        setEditorAppData(function (prev) { return (__assign(__assign({}, prev), { settings: updatedSettings })); });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["toolbar-area"] },
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["back-button"], onClick: handleBackToDeveloperPage, title: t("Back to developer page") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowLeftFromLine, style: { marginRight: "8px" } })),
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["toolbar-center"] },
                react_1.default.createElement(DeveloperToolbar_1.default, { tabs: tabs, activeTab: activeTab, onTabChange: handleTabChange }))),
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["app-editor-container"] },
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default.canvas, ref: canvasRef, style: { position: "relative" } },
                react_1.default.createElement(AppPreview_1.default, null),
                react_1.default.createElement("div", { className: AppEditor_module_css_1.default["canvas-gear"], onClick: function () { return handleTabChange("Settings"); }, title: t("Open Settings") },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faSliders, style: { color: "var(--primary-color)" } })),
                react_1.default.createElement(material_1.Drawer, { variant: "persistent", anchor: "right", open: activeTab === "Settings", container: canvasRef.current, ModalProps: { disablePortal: true }, PaperProps: {
                        style: {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            height: "100%",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                            borderRadius: "8px",
                            width: "350px",
                            zIndex: 0
                        },
                    } },
                    react_1.default.createElement(SettingsDrawerContent_1.default, { onClose: function () { return handleTabChange("App Info"); }, appData: editorAppData }))),
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["editor-sidebar"] },
                react_1.default.createElement(AppEditorSidebar_1.default, { activeTab: activeTab, appData: editorAppData, onUpdateSetting: handleUpdateSetting, onRemoveSetting: handleRemoveSetting, onAppDataUpdate: handleAppDataUpdate })))));
};
exports.default = AppEditor;
